module.exports = __webpack_public_path__ + "static/media/objects_03.7ee13cf9.svg";